/**
 * Murmelie — Premium Interactions (Phase 2)
 * Subtle, restrained scroll-based animations
 * IntersectionObserver for fade-in reveals
 */
(function () {
  'use strict';

  /* Respect reduced motion */
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  /* Skip in Shopify editor */
  if (window.Shopify && window.Shopify.designMode) return;

  /**
   * Fade-in on scroll using IntersectionObserver
   */
  function initFadeIn() {
    const elements = document.querySelectorAll('.murmelie-fade-in');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('murmelie-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /**
   * Initialize on DOM ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }

  /**
   * Re-initialize when Shopify sections are loaded dynamically
   */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initFadeIn, 100);
  });
})();
